export default __webpack_public_path__ + "static/311-4170fe7205ed1a55cd9b4d44b332abaa.gif";